<template>
    <div class="labels__form">
        <div class="form__group">
            <label for="name" class="form__label">Name</label>
            <a v-if="label" @click.prevent="remove" class="labels__remove" href="#">Remove</a>
            <input ref="name" v-model="form.name" id="name" name="name" tabindex="1" class="form__input" autofocus autocomplete="off">
            <p v-if="form.errors.has('name')" class="form__help form__help--error">{{ form.errors.get('name') }}</p>
        </div>
        <div class="form__group">
            <label for="color" class="form__label">Select a color</label>
            <ul class="labels__items">
                <li @click="pickColor(color)" class="labels__item" :key="color" v-for="color in colors">
                    <span class="label label--option" :class="{[`label--${color}`]: true, 'label--selected': isSelected(color)}"></span>
                </li>
            </ul>
            <p v-if="form.errors.has('color')" class="form__help form__help--error">{{ form.errors.get('color') }}</p>
        </div>
        <footer class="labels__footer">
            <button @click.prevent="close" class="button button--small button--outline">Cancel</button>
            <button v-if="label" @click.prevent="update" class="button button--small button--primary">Save</button>
            <button v-else @click.prevent="create" class="button button--small button--primary">Create</button>
        </footer>
    </div>
</template>
<script>
/* global app */
import Form from '../../helpers/Form'

export default {
    props: {
        label: {
            type: Object,
            default: null
        }
    },

    data () {
        return {
            colors: app.config.LABEL_COLORS,
            form: new Form({
                name: '',
                color: ''
            })
        }
    },

    created () {
        if (this.label) {
            this.form.name = this.label.name
            this.form.color = this.label.color
        }
    },

    methods: {
        newLabel () {
            this.isEditing = true
        },

        close () {
            this.$emit('closed')
        },

        pickColor (color) {
            this.form.color = color
        },

        isSelected (color) {
            return this.form.color === color
        },

        create () {
            this.$store.dispatch('channel/addLabel', this.form).then((label) => {
                this.$emit('created', label)
                this.close()
            })
        },

        update () {
            let data = {
                labelId: this.label.id,
                form: this.form
            }

            this.$store.dispatch('channel/updateLabel', data).then(() => {
                this.close()
            })
        },

        remove () {
            this.$store.dispatch('channel/removeLabel', this.label.id).then(() => {
                this.close()
            })
        }
    }
}
</script>
